import { render, staticRenderFns } from "./NoCertainItemsCustomer.vue?vue&type=template&id=6d4eb59a&scoped=true"
import script from "./NoCertainItemsCustomer.vue?vue&type=script&lang=js"
export * from "./NoCertainItemsCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4eb59a",
  null
  
)

export default component.exports